export default "__VITE_ASSET__BZ611$Jq__"